import { Pipe, PipeTransform } from '@angular/core';
import { TransformObjectService } from './transform-object.service';

@Pipe({ name: 'transformObject' })
export class TransformObjectPipe<T> implements PipeTransform
{
  constructor(private transformObjectService: TransformObjectService) {}

  transform(object: any, objectKey: any, objDefaultValue?: Object): T | any {
    return object && this.transformObjectService.transformObject<T | any>(object, objectKey, objDefaultValue) as T | any || null;
  }

}
